var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { width: "100%" } },
    [
      _c(
        "w-col",
        { attrs: { lg: "2", sm: "4", xs: "12" } },
        [
          _c("w-input-number", {
            ref: "qty",
            attrs: { label: _vm.$ct("qty"), fancy: "", autofocus: "" },
            on: {
              blur: function ($event) {
                return _vm.update()
              },
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focusRef("productSku")
              },
            },
            model: {
              value: _vm.amount,
              callback: function ($$v) {
                _vm.amount = $$v
              },
              expression: "amount",
            },
          }),
        ],
        1
      ),
      !_vm.single
        ? _c("w-col", { attrs: { lg: "3", sm: "8", xs: "12" } }, [
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("app-product-sku-autocomplete", {
                  ref: "productSku",
                  style: { flexGrow: 1, marginRight: "5px" },
                  attrs: { "create-modal-if-not-exist": "" },
                  on: {
                    input: function ($event) {
                      return _vm.productSelected($event)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.focusRef("productDescription")
                    },
                  },
                  model: {
                    value: _vm.product,
                    callback: function ($$v) {
                      _vm.product = $$v
                    },
                    expression: "product",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { lg: _vm.descriptionCols, xs: _vm.single ? 8 : 12 } },
        [
          _c("w-input", {
            ref: "productDescription",
            attrs: { label: _vm.$ct("name"), fancy: "" },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focusRef(
                  _vm.showInfoField ? "info" : "stockLocationSelect"
                )
              },
              blur: function ($event) {
                return _vm.update()
              },
            },
            model: {
              value: _vm.productDescription,
              callback: function ($$v) {
                _vm.productDescription = $$v
              },
              expression: "productDescription",
            },
          }),
        ],
        1
      ),
      _vm.showInfoField
        ? _c(
            "w-col",
            { attrs: { lg: _vm.single ? 4 : 3, xs: "12" } },
            [
              _c("w-input", {
                ref: "info",
                attrs: { label: _vm.$ct("info"), fancy: "" },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.focusRef("stockLocationSelect")
                  },
                  blur: function ($event) {
                    return _vm.update()
                  },
                },
                model: {
                  value: _vm.info,
                  callback: function ($$v) {
                    _vm.info = $$v
                  },
                  expression: "info",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.productHasSizes
        ? _c(
            "w-col",
            { attrs: { lg: "2", xs: "4" } },
            [
              _c("w-select", {
                ref: "sizeSelect",
                attrs: {
                  items: _vm.sizeOptions,
                  fancy: "",
                  label: _vm.$ct("size"),
                },
                on: {
                  input: function ($event) {
                    return _vm.update()
                  },
                },
                model: {
                  value: _vm.sizeTableEntryID,
                  callback: function ($$v) {
                    _vm.sizeTableEntryID = $$v
                  },
                  expression: "sizeTableEntryID",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.hasModuleTraceability
        ? _c(
            "w-col",
            { attrs: { xs: _vm.productHasSizes ? 4 : 6 } },
            [
              _c("w-input", {
                ref: "trackingNumber",
                attrs: { fancy: "", label: _vm.$ct("tracking-number") },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.focusRef("trackingNumberValidUntil")
                  },
                  input: function ($event) {
                    return _vm.update()
                  },
                },
                model: {
                  value: _vm.trackingNumber,
                  callback: function ($$v) {
                    _vm.trackingNumber = $$v
                  },
                  expression: "trackingNumber",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.hasModuleTraceability
        ? _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-date-picker", {
                ref: "trackingNumberValidUntil",
                style: { flexGrow: 1 },
                attrs: {
                  fancy: "",
                  label: _vm.$ct("tracking-number-valid-until"),
                  nullable: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.update()
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.focusRef("buttonAdd")
                  },
                },
                model: {
                  value: _vm.trackingNumberValidUntil,
                  callback: function ($$v) {
                    _vm.trackingNumberValidUntil = $$v
                  },
                  expression: "trackingNumberValidUntil",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { lg: "3", xs: "12" } },
        [
          _c("app-stock-location-select", {
            ref: "stockLocationSelect",
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focusRef("datePicker")
              },
              input: function ($event) {
                return _vm.update()
              },
            },
            model: {
              value: _vm.locationID,
              callback: function ($$v) {
                _vm.locationID = $$v
              },
              expression: "locationID",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "2", xs: "6" } },
        [
          _c("w-date-picker", {
            ref: "datePicker",
            attrs: {
              label: _vm.$ct("date"),
              "max-date": _vm.maxDate,
              fancy: "",
              "popover-visibility": "focus",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focusRef("price")
              },
              input: function ($event) {
                return _vm.update()
              },
            },
            model: {
              value: _vm.dateCreated,
              callback: function ($$v) {
                _vm.dateCreated = $$v
              },
              expression: "dateCreated",
            },
          }),
        ],
        1
      ),
      _c("w-col", { attrs: { lg: _vm.single ? 3 : 2, xs: "6" } }, [
        _c(
          "div",
          [
            _c("app-contact-search", {
              attrs: {
                "group-id": _vm.contactGroupId,
                label: _vm.searchSupplierLabel,
                value: _vm.supplier,
                fancy: "",
              },
              on: {
                input: function ($event) {
                  return _vm.selectSupplier($event)
                },
              },
            }),
            _c(
              "w-link",
              {
                staticClass: "contact-group-button",
                on: {
                  click: function ($event) {
                    return _vm.cycleContactGroup()
                  },
                },
              },
              [
                _c("w-fa", { attrs: { icon: _vm.contactIconLeft } }),
                _vm._v(" " + _vm._s(_vm.contactIconLeftTooltip)),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "w-col",
        {
          style: { flexWrap: "nowrap", flexDirection: "row" },
          attrs: { lg: _vm.single ? 4 : 5, xs: "6" },
        },
        [
          _c("w-input-number", {
            ref: "price",
            style: { flexGrow: 1 },
            attrs: {
              label: _vm.$ct("buyPrice"),
              decimals: _vm.DecimalSettings.Buy,
              fancy: "",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.focusRef("trackingNumber")
              },
              change: function ($event) {
                return _vm.update()
              },
            },
            model: {
              value: _vm.buyPrice,
              callback: function ($$v) {
                _vm.buyPrice = $$v
              },
              expression: "buyPrice",
            },
          }),
          _vm.value.ID == 0
            ? _c("w-input-number", {
                staticClass: "ml",
                attrs: { label: _vm.$ct("newStock"), disabled: "", fancy: "" },
                model: {
                  value: _vm.newStock,
                  callback: function ($$v) {
                    _vm.newStock = $$v
                  },
                  expression: "newStock",
                },
              })
            : _vm._e(),
          !_vm.single
            ? _c(
                "w-button",
                {
                  ref: "buttonAdd",
                  staticClass: "buttonAddSalesRow ml",
                  attrs: { lg: "", round: "", disabled: _vm.addDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.add()
                    },
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      )
                        return null
                      return _vm.add()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              )
            : _vm._e(),
          _c("input", {
            staticStyle: {
              position: "absolute",
              left: "-10000px",
              top: "-500px",
            },
            attrs: { type: "text" },
            on: {
              focus: function ($event) {
                return _vm.focusRef("qty")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }